import script from "./addressInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./addressInput.vue?vue&type=script&setup=true&lang=ts"

import "./addressInput.vue?vue&type=style&index=0&id=59151bd4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59151bd4"]])

export default __exports__